/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useEffect, useState } from 'react';

import hashUserId from './hashUserId';

export default function useInitStatsigParams(userId, currentOrganizationId, currentOrganizationInfo) {
  const [isStatsigParamsInitialized, setIsStatsigParamsInitialized] = useState(false);
  const [hashedUserId, setHashedUserId] = useState(null);

  useEffect(() => {
    async function initialize(userIdVal) {
      setHashedUserId(await hashUserId(userIdVal));
      setIsStatsigParamsInitialized(true);
    }

    if (userId && currentOrganizationId && currentOrganizationInfo?.salesPlan?.type) {
      initialize(userId);
    }
  }, [userId, currentOrganizationId, currentOrganizationInfo?.salesPlan?.type]);

  return { isStatsigParamsInitialized, hashedUserId };
}
